<template>
  <aside v-bind:class="routeClass">
    <template v-if="sidebar == 'outcome'">
      <h5>Questionnaires</h5>
      <QuestionnaireList></QuestionnaireList>
    </template>

    <!-- Patient module sidebar -->
    <template v-else>
      <EnrollPatient v-if="getUserType !== 'observer'"></EnrollPatient>

      <ImportErrors v-if="getUserType !== 'observer'"></ImportErrors>
      <br v-if="getUserType !== 'observer'" />
      <PatientList></PatientList>
      <div class="separator"></div>
      
      <PatientFilters></PatientFilters>
      <template v-if="hasReachout && getUserType !== 'observer'">
        <div class="separator"></div>
        <h5>Patient Messages</h5>
        <ReachoutList></ReachoutList>
      </template>
      <!-- <template
        v-if="getProviderList.length === 1 && getUserType !== 'observer'"
      >
        <div class="separator"></div>
        <h5>
          Filters
          <router-link
            to="/filter"
            class="add-filter"
            v-if="getUserType !== 'observer'"
          >
            <AddIcon></AddIcon>
            <span>Add</span>
          </router-link>
        </h5>
        <FilterList></FilterList>
      </template> -->
      <!-- <template>
        <div class="separator"></div>
        <h5 v-if="getUserType === 'observer'">Filters</h5>
        <h5 v-else>DEVICE / PHARMA</h5>
        <TagList></TagList>
      </template> -->
      <template v-if="false">
        <h5 class="with-icon">
          <i
            :class="[
              'el-icon-arrow-right expand-icon',
              { open: openFilterList },
            ]"
            @click="expandFilterList"
          ></i>
          Filters
        </h5>
        <transition name="expand">
          <div v-if="openFilterList" class="provider-filter-list">
            <div
              v-for="providerId in this.getProvidersIdArray"
              :key="providerId"
              class="provider-name"
            >
              <h4>
                {{ getProviderNameById(providerId) }}
                <router-link
                  to="/filter"
                  class="add-filter"
                  @click="setCurrentProvider(providerId)"
                >
                  <AddIcon></AddIcon>
                  <span>Add</span>
                </router-link>
              </h4>
              <FilterList :id="providerId"></FilterList>
            </div>
          </div>
        </transition>
      </template>
    </template>
  </aside>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex"
import RouteMixin from "../mixin/route"

import SidebarActions from "./action/components"
import SidebarLists from "./list/components"

import PatientFilters from "./list/PatientFilters"

import AddIcon from "@/module/add/icons/AddRow"

export default {
  name: "sidebar",
  mixins: [RouteMixin],

  props: {
    sidebar: {
      type: String,
    },
  },

  data() {
    return {
      openFilterList: true,
    }
  },

  computed: {
    // Map the full route
    ...mapState("provider", ["provider", "id", "overview"]),
    ...mapGetters("content", ["getContent"]),
    ...mapGetters("provider", [
      "getProviderList",
      "getProviderName",
      "getProviderNameById",
      "getProvidersIdArray",
    ]),
    ...mapGetters(["getUserType"]),

    providers() {
      return this.getProviderList
    },

    multipleProviders() {
      return this.providers.length > 1
    },

    /**
     * @func filters
     * @desc Array of all active filters for this
     */
    filters() {
      if (this.provider) return this.provider.filter || []
      return []
    },

    patientCount() {
      if (this.patients) return Object.keys(this.patients).length
      return 0
    },
    count() {
      if (this.provider) return this.provider.count
      else return {}
    },
    hasReachout() {
      try {
        const profileList = [
          ...new Set(
            this.getProviderList
              .flatMap(({ profile }) => profile)
              .map(({ id }) => id)
          ),
        ]
        return profileList.some((profile) => {
          const profileContent = this.getContent("profile", profile)
          if (profileContent)
            return profileContent.feature.some(({ id }) => id === "reach_out")
          return false
        })
      } catch (error) {
        console.error("Problem in calculating hasReachout ", error)
        return true
      }
    },
  },

  methods: {
    ...mapActions("provider", ["setCurrentProvider"]),
    expandFilterList(event) {
      this.openFilterList = !this.openFilterList
      event.preventDefault()
    },
  },

  components: {
    ...SidebarActions,
    ...SidebarLists,
    AddIcon,
    PatientFilters
  },
}
</script>

<style lang="scss" scoped>
@import "../style-config.scss";
@import "style.scss";
</style>
